export const PAGE_X_PADDING =
  "px-8 [scrollbar-gutter:stable] xl:px-12 2xl:px-20";
export const PAGE_DOCUMENT_MAX_WIDTH = "max-w-[1280px]";
export const logo = "/logos/Black/BLACK_TEAL.png";
export const loginLogo = "/logos/White/saltstudios.svg";
export const BRAND_NAME = "Salt Dash";
export const truncateLength = 40;
